const getOldestIndexDate = (timestamps) => {
	if (!Array.isArray(timestamps) || timestamps.length === 0) return null;

	const dates = timestamps.map((timestamp) => new Date(timestamp?.lastSuccessfulExecution ?? NaN));
	// One unknown index makes the oldest date unknown, so don't show a newer one.
	if (dates.some((date) => Number.isNaN(date.getTime()))) return null;

	return new Date(Math.min(...dates.map((date) => date.getTime())));
};

export { getOldestIndexDate };
